module.exports = __webpack_public_path__ + "img/Frame 2134.7860bb15.png";